// /src/pages/AboutProject.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import { getLangFromPath } from "../i18n/lang";

import AboutProjectUk from "./static/AboutProject.uk.jsx";
import AboutProjectEn from "./static/AboutProject.en.jsx";
import AboutProjectIt from "./static/AboutProject.it.jsx";
import AboutProjectFr from "./static/AboutProject.fr.jsx";


export default function AboutProject() {
  const loc = useLocation();
  const lang = getLangFromPath(loc.pathname);
  const Map = { uk: AboutProjectUk, en: AboutProjectEn, it: AboutProjectIt, fr: AboutProjectFr };

  const L = Map[lang] || AboutProjectUk;
  return <L />;
}
